module.exports = {
  messages: {
    CARDS_SECTION_DESCRIPTION: 'Oft gesuchte Job-Kriterien:',
    CARDS_SECTION_REGISTRATION_BUTTON_TEXT: "Profil anlegen und los geht's",
    CARDS_SECTION_REGISTRATION_TEXT:
      'Mit einem XING Profil hast Du noch viel mehr Such-Optionen.',
    CARDS_SECTION_TITLE: 'Entdecke Jobs auf die smarte Art.',
    CAREER_HUB_TEASER_CARD_DESCRIPTION:
      'Die besten Artikel und Tipps von erfahrenen Profis und Insider·innen.',
    CAREER_HUB_TEASER_CARD_TITLE:
      'Der XING Karriere-Ratgeber: damit Du Bescheid weißt',
    COMPANIES_SECTION_SUBTITLE: 'Entdecke Unternehmen, die zu Dir passen.',
    COMPANIES_SECTION_TITLE: 'Beliebte Arbeitgeber auf XING',
    CP_HIRING: 'Offene Jobs',
    'CP_TOP_COMPANIES_CARD_BUTTON.one': '{value} Job ansehen',
    'CP_TOP_COMPANIES_CARD_BUTTON.other': '{value} Jobs ansehen',
    CP_TOP_COMPANIES_CARD_HIGHLIGHT:
      '{percentage} % haben diesen Arbeitgeber auf kununu weiterempfohlen.',
    CRATE_LOSP_CAREER_HUB_CARD_DESCRIPTION:
      'Lies die besten Tipps und Artikel von erfahrenen Profis und Insider·innen.',
    CRATE_LOSP_CAREER_HUB_CARD_TITLE: 'Der XING Karriere-Ratgeber',
    CRATE_LOSP_COMPANIES_SECTION_SUBTITLE:
      'Schau mal, wer gerade so alles einstellt.',
    CRATE_LOSP_COMPANIES_SECTION_TITLE:
      '270.000+ Arbeitgeber brauchen Leute wie Dich',
    CRATE_LOSP_CV_CARD_DESCRIPTION: 'Sieht top aus und ist ratzfatz erstellt.',
    CRATE_LOSP_CV_CARD_TITLE: 'Dein perfekter Lebenslauf als PDF',
    CRATE_LOSP_PROFILE_CARD_DESCRIPTION:
      'Mit einem XING Profil kommen die Jobs automatisch zu Dir und Du verpasst nie wieder eine gute Gelegenheit.',
    CRATE_LOSP_PROFILE_CARD_TITLE: 'Lass Dich einfach finden!',
    CRATE_LOSP_RECRUITERS_SECTION_SUBTITLE:
      'Tritt direkt in Kontakt mit den HR-Profis von beliebten Arbeitgebern.',
    CRATE_LOSP_RECRUITERS_SECTION_TITLE:
      'Über 20.000 Recruiter·innen freuen sich auf Dich',
    CRATE_LOSP_REGISTER_BUTTON: 'Jetzt Profil anlegen',
    CRATE_LOSP_REGISTER_WITH_GOOGLE_BUTTON: 'Weiter mit Google',
    DESCRIPTION_CARD_1: 'Falls Du zu Hause am besten bist.',
    DESCRIPTION_CARD_2: 'Arbeite doch einfach, wann Du willst.',
    DESCRIPTION_CARD_3: 'Schau mal, was für Dich alles möglich ist.',
    DESCRIPTION_CARD_4: 'Hier werden Deine Gehaltsvorstellungen übertroffen.',
    DESCRIPTION_CARD_5: 'Damit noch Zeit für anderes bleibt.',
    DESCRIPTION_CARD_6: 'Falls Du erstmal klein anfangen willst.',
    ERROR_REGISTER_EMAIL_MAX_CHANGE:
      'Du kannst Deine E-Mail-Adresse höchstens 10 mal ändern.',
    JOBS_FIND_JOBS_RECRUITERS_LINK: 'Jobs posten? <a>Geht hier.</a>',
    JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE: 'Jobs posten?',
    JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE: 'Geht hier.',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Jobs finden',
    JOBS_FIND_JOBS_SEARCH_LOCATION_PLACEHOLDER: 'Standort',
    JOBS_FIND_JOBS_SEARCH_PLACEHOLDER: 'Job-Titel eingeben',
    JOBS_FIND_JOBS_TITLE: 'Jobs finden',
    JOBS_JOB_TEASER_SAVE: 'Job merken',
    JOBS_JOB_TEASER_SAVED: 'Gemerkt',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_ONE: 'Über eine Million Jobs',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_THREE:
      'Profi-Ratgeber für die Job-Suche',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_TWO: 'Über 21 Mio. Mitglieder',
    JOBS_RECENT_SEARCH_EMPTY: 'Alle Jobs',
    JOBS_SEARCH_AI_HEADLINE: 'Beschreib der XING KI Deinen Wunsch-Job',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_1: 'Beschreib mal Deinen Traumjob …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_10:
      'Erzähl auch von Deinen Erfahrungen und Fähigkeiten …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_2:
      'Schreib einfach in ganz natürlicher Sprache …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_3: 'Jobs, die Du gern machen würdest …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_4:
      'Deine Ideen für Deinen nächsten Karriere-Schritt …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_5:
      'Job-Titel, Karriere-Stufe, Wunsch-Gehalt, …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_6:
      'Alles, was Dir im Job-Leben wichtig ist …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_7: 'Je konkreter, desto besser …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_8:
      'Teilzeit oder Vollzeit, Büro oder Home-Office, …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_9:
      'Lieber einfache Sätze statt viele Schlagwörter …',
    JOBS_SEARCH_AI_SALARY_SUGGESTION: 'Ich will mehr verdienen',
    JOBS_SEARCH_AI_SALARY_SUGGESTION_SUBTITLE: 'Finde lukrativere Jobs',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION: 'Such mit meinem Profil',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE: 'Finde Deinen nächsten Job',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION: 'Hilfe beim Quereinstieg',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE:
      'Entdecke mit XING völlig neue Karriere-Chancen.',
    LEBENSLAUF_TEASER_CARD_DESCRIPTION:
      'Erhöhe im Handumdrehen Deine Chancen auf Job-Interviews.',
    LEBENSLAUF_TEASER_CARD_TITLE: 'Dein perfekter Lebenslauf: ratzfatz als PDF',
    LOGGED_OUT_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      'Über 1 Mio. Jobs ✓ 20.000 Recruiter·innen ✓ Gehaltsangaben ✓ Arbeitgeber-Bewertungen. Definiere Deine Job-Wünsche und mach Dein XING!',
    LOGGED_OUT_STARTPAGE_META_TITLE_JOB_SEARCH:
      'XING - Finde den Job, der zu Dir passt. Oder lass Dich finden!',
    LOSP_APPLE_BUTTON: 'Laden im App Store',
    LOSP_GOOGLE_BUTTON: 'Laden bei Google Play',
    LOSP_JOBS_SECTION_SUBTITLE: 'Das hier könnte Dir gefallen:',
    LOSP_JOBS_SECTION_TITLE: 'Mehr als 1 Mio. Jobs für Dich',
    LOSP_KEYWORDS_ACCOUNTANT: '🧮 Buchhalter·in',
    LOSP_KEYWORDS_ADMINISTRATION: '🏫 Verwaltung',
    LOSP_KEYWORDS_ANALYST: '📈 Data Analyst·in',
    LOSP_KEYWORDS_BANKER: '💸 Banker·in',
    LOSP_KEYWORDS_CALLCENTER: '📞 Callcenter',
    LOSP_KEYWORDS_CAREERCHANGER: '👣 Quereinsteiger·in',
    LOSP_KEYWORDS_CARETAKER: '👨‍🔧 Hausmeister·in',
    LOSP_KEYWORDS_CONTROLLER: '🎚️ Controller·in',
    LOSP_KEYWORDS_DESIGN: '🎨 Design-Jobs',
    LOSP_KEYWORDS_FLIGHTATTENDANT: '🛫 Flugbegleiter·in',
    LOSP_KEYWORDS_FORKLIFT: '👷 Staplerfahrer·in',
    LOSP_KEYWORDS_FOUNDATION: '🏛️ Stiftung',
    LOSP_KEYWORDS_FREELANCE: '👨🏻‍💻 Freelance-Jobs',
    LOSP_KEYWORDS_HEALTH: '🥕 Gesundheitsmanager·in',
    LOSP_KEYWORDS_LOGISTICS: '📦 Logistik-Jobs',
    LOSP_KEYWORDS_MARKETING: '📣 Marketing-Jobs',
    LOSP_KEYWORDS_MUSEUM: '🖼️ Museums-Jobs',
    LOSP_KEYWORDS_NURSERY: '👶 Erzieher·in',
    LOSP_KEYWORDS_OFFICECLERK: '👩‍💻 Bürokauffrau',
    LOSP_KEYWORDS_PROJECTMANAGER: '🤹 Projektmanager·in',
    LOSP_KEYWORDS_PSYCHOLOGIST: '🛋️ Psycholog·in',
    LOSP_KEYWORDS_SALES: '💼 Außendienstler·in',
    LOSP_KEYWORDS_SALES2: '💰 Vertrieb',
    LOSP_KEYWORDS_SECURITY: '👮🏻 Sicherheitsdienst',
    LOSP_KEYWORDS_SOCIALMEDIA: '🤳 Social-Media-Manager·in',
    LOSP_KEYWORDS_SOCIALWORKER: '👨‍👧‍👦 Sozialpädagog·in',
    LOSP_KEYWORDS_SOCIALWORKER2: '❤️‍🔥 Sozialarbeiter·in',
    LOSP_KEYWORDS_SUSTAINABILITY: '🌿 Nachhaltigkeits-Jobs',
    LOSP_KEYWORDS_TRUCK: '🚚 Lkw-Fahrer·in',
    LOSP_KEYWORDS_WORKINGSTUDENT: '🧑🏽‍🎓 Werkstudent·in',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BERLIN: 'Berlin',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BUTTON: 'Arbeitsorte',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HAMBURG: 'Hamburg',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HEADLINE:
      'In welcher Stadt möchtest Du gern arbeiten?',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_MUNICH: 'München',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BODY:
      'Gib uns bitte mindestens eine Info zu Deinen Job-Wünschen, damit wir Dir passende Jobs empfehlen können.',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BUTTON: 'Alles klar',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_HEADLINE:
      'Ohne Infos geht’s leider nicht.',
    LOSP_PREFERENCES_EXPERIMENT_HEADLINE:
      'Lass Dich von Recruiter·innen finden',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_BUTTON: 'Karriere-Stufe',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_ENTRY: 'Berufseinsteiger·in',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_HEADLINE:
      'Welche Karriere-Stufe soll Dein nächster Job haben?',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_MANAGER: 'Manager·in',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_PROFESSIONAL: 'Mit Berufserfahrung',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_DISCIPLINES: 'Tätigkeitsfelder',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_HEADLINE:
      'Hast du weitere Kriterien für deinen Job?',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_INDUSTRIES: 'Branchen',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_JOBTITLE: 'Job-Titel',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_WORKING_HOURS: 'Arbeitszeit',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_BUTTON: 'Dein Arbeitsplatz',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HEADLINE:
      'Wie möchtest Du in Zukunft arbeiten?',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HOMEOFFICE: '100 % Zuhause',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_ONSITE: 'Im Büro',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_BUTTON: 'Gehalt',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_EIGHTY: '80.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY: '40.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY_FIVE: '45.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_HEADLINE:
      'Was ist Dein jährliches Wunsch-Gehalt?',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_SIXTY: '60.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_THIRTY: '30.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SAVE: 'Job-Wünsche speichern',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BODY:
      'Viele spannende Arbeitgeber und über 20.000 Recruiter·innen suchen auf XING nach Leuten wie Dir. Lass Dich finden und bekomme Job-Empfehlungen, die wirklich zu Dir passen: Mit Deinem eigenen XING Profil.',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BUTTON: 'Jetzt anmelden',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_HEADLINE:
      'Lass die Jobs einfach zu Dir kommen.',
    LOSP_PREFERENCES_EXPERIMENT_SEE_MORE: 'Mehr anzeigen',
    LOSP_PREFERENCES_EXPERIMENT_SUBHEADLINE:
      '… statt selber einen Job zu suchen. Sag uns einfach, was Dir wichtig ist.',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_HOME_OFFICE: '100 % Zuhause',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_MOSTLY_HOME: 'Überwiegend Zuhause',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_OFFICE: 'Vor Ort',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_PARTLY_HOME: 'Teilweise Zuhause',
    LOSP_QR_CODE: 'QR-Code für den direkten App-Download',
    LOSP_RECRUITERS_SECTION_COMPANY_CTA: 'Jobs ansehen',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AIRBUS:
      '80 % Weiterempfehlung in den letzten 2 Jahren',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AMAZON:
      'Vorteile für Mitarbeitende: Rabatte, Parkplatz, Mitarbeiter-Events',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AOK:
      'Über 1.440 Bewertungen mit "sehr gut"',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AUDI:
      '86 % sind mit ihren Gehältern zufrieden',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BAHNE_GROTH:
      'Recruiter für Positionen im Headquarter der flaschenpost',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BASF:
      'Häufig bestätigte Benefits: Flexible Arbeitszeiten, Home-Office, Betriebliche Altersvorsorge',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BMW:
      'Häufig bestätigte Benefits: Kantine, Betriebliche Altersvorsorge, Rabatte',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BOSCH:
      'Häufig bestätigte Benefits: Flexible Arbeitszeiten, Betriebsarzt',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_CAROLA_LUDEWIG:
      'Recruiting Sicherheitsfachleute verschiedener Level',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BAHN:
      '74 % Weiterempfehlung in den letzten 2 Jahren',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BANK:
      'Häufig bestätigte Benefits: Flexible Arbeitszeiten, Betriebliche Altersvorsorge',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_POST:
      'Über 12.250 Bewertungen von Mitarbeitenden und Bewerber·innen',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DM:
      '70 % Weiterempfehlung in den letzten 2 Jahren',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DUERENHOFF_GMBH:
      'Top 10 kununu Rating: Deutschlands familienfreundlichste Arbeitgeber',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FATMA_KOC:
      'Active Sourcing für den Bereich Financial Services',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FINJA_STRUBER:
      'Recruiterin für die Unternehmenszentrale bei ROSSMANN',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_HUSEYIN_YALCIN:
      'Reply Rate: Weniger als 3 Stunden',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_IKEA:
      'Häufig bestätigte Benefits: Rabatte, Kantine, Betriebliche Altersvorsorge',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ISABEL_STRUSCHKA:
      'Ansprechpartnerin für Finanzen, IT, People and Culture',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_GOTZE:
      'Recruiting für IT-Fach- und Führungskräfte',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_SCHENGBER:
      'Reply Rate: Weniger als 4 Stunden',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JOHANNA_ECKERT:
      'Recruiterin im Bereich Tax & Audit/Wirtschaftsprüfung',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JONAS_MASANNECK:
      'Recruiter im Bereich Non-Tech & Life Sciences',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JULIA_REICHHOFER:
      'Recruiterin für alle Positionen für die Schmersal Gruppe',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KAUFLAND:
      'Über 2.867 Bewertungen von Mitarbeitenden und Bewerber·innen',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KRISTIN_SEMELKA:
      'Recruiterin – auch im Bereich Ausbildung',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_LIDL: 'kununu Top-Company 2023',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MALTE_BALMER:
      'Dein erster Ansprechpartner bei Fragen zu OTTO Jobs ',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MARIA_HEUCKE:
      'Recruiting mit Herz & Humor #WeEmpowerPeople',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MEINESTADT_DE:
      '88 % Weiterempfehlung in den letzten 2 Jahren',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MIRIAM_DJAMBOU:
      'Vermittlung im Bereich IT & Engineering',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_OTTOBOCK:
      'Häufig bestätigte Benefits: Gleitzeit, Betriebsarzt',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_PORSCHE:
      '95 % sind mit ihren Gehältern zufrieden ',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_RALPH_OSTERMEIER:
      'Dein Ansprechpartner für die IT-Jobs bei EDEKA',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_REWE:
      '61 % Weiterempfehlung in den letzten 2 Jahren',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROBIN_MAURER:
      'Recruiting & Employer Branding für drei Unternehmen',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROSSMANN:
      'Über 1.621 Bewertungen von Mitarbeitenden und Bewerber·innen',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SAP:
      '93 % Weiterempfehlung in den letzten 2 Jahren',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SARAH_BAUDZUS:
      'Seit mehr als 10 Jahren in der Pflege & im Krankenhaus',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SIEMENS:
      '67 % bestätigen: Flexible Arbeitszeiten',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_STEFANIE_KLOCK:
      'Vermittlung von Sales- & Marketing-Experten',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VANESSA_STRAUCH:
      'Recruiterin im Bereich Transport & Logistik',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VERONIKA_GERSDORF:
      'Recruiterin für unsere Studios und Zentrale',
    LOSP_RECRUITERS_SECTION_RECRUITER_CTA: 'Profil ansehen',
    LOSP_SEARCH_INSPIRATION_CAREER_LEVEL: 'Deine Karriere-Stufe',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_1:
      'Falls Du zu Hause am besten bist.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_5:
      'Damit noch Zeit für anderes bleibt.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_6:
      'Falls Du erstmal klein anfangen willst.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_CAREER_LEVEL_HEADLINE:
      'Was ist Deine bevorzugte Karrierestufe?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION:
      'Sag uns, was Dir wichtig ist. Dann können wir Dir bessere Empfehlungen geben.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION_2: 'Geht auch ganz fix!',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_SUBHEADLINE:
      'Sag uns, was Dir wichtig ist. Dann können wir Dir bessere Empfehlungen geben. Geht auch ganz fix!',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_TITLE: 'Deine Job-Wünsche',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_SALARY_HEADLINE:
      'Wie hoch sind Deine Gehaltsvorstellungen?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_TITLE: 'Deine Job-Wünsche',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_WORKPLACE_HEADLINE:
      'Wie möchtest Du in Zukunft arbeiten?',
    LOSP_SEARCH_INSPIRATION_SALARY: 'Dein Wunsch-Gehalt',
    LOSP_SEARCH_INSPIRATION_SET_PREFERENCES: 'Job-Wünsche speichern',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_1: 'Remote-Jobs',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_3: 'Jobs als Quereinsteiger·in',
    LOSP_SEARCH_INSPIRATION_WORKPLACE: 'Dein Arbeitsplatz',
    LOSP_SEO_SECTION_COMPANIES_DIRECTORY: 'Unternehmen von A bis Z',
    LOSP_SEO_SECTION_HEADER_DIRECTORIES: 'Verzeichnisse',
    LOSP_SEO_SECTION_HEADER_JOB_ROLES: 'Positionen',
    LOSP_SEO_SECTION_HEADER_TOP_LOCATIONS: 'Top-Standorte',
    LOSP_SEO_SECTION_HEADER_TOP_SKILLS: 'Top-Fähigkeiten',
    LOSP_SEO_SECTION_JOBS_DIRECTORY: 'Jobs von A bis Z',
    LOSP_SEO_SECTION_PEOPLE_DIRECTORY: 'Mitglieder von A bis Z',
    PROFILE_TEASER_CARD_DESCRIPTION:
      'Kostet nichts und eröffnet Dir alle Optionen bei Deiner Job-Suche.\t',
    PROFILE_TEASER_CARD_TITLE: "Mach's Dir leicht: mach Dir ein XING Profil",
    QR_CODE_BANNER_SUBTITLE:
      'und Du hast Deinen nächsten Job quasi schon in der Tasche.',
    QR_CODE_BANNER_TITLE: 'Hol Dir die XING App',
    RECRUITERS_SECTION_FIRST_SUBTITLE:
      'Ein eigenes XING Profil öffnet Dir jede Menge Türen auf dem Weg zu Deinem Traum-Job.',
    RECRUITERS_SECTION_FIRST_TITLE: 'XING - Das Jobs-Netzwerk',
    RECRUITERS_SECTION_FLAG_COMPANIES: 'Offene Jobs',
    RECRUITERS_SECTION_FLAG_RECRUITERS: 'Stellt ein',
    RECRUITERS_SECTION_REGISTER_BUTTON: 'Jetzt Profil anlegen',
    RECRUITERS_SECTION_REGISTER_WITH_GOOGLE_BUTTON: 'Weiter mit Google',
    RECRUITERS_SECTION_SECOND_SUBTITLE:
      'Tritt direkt in Kontakt mit über 20.000 Recruiter·innen von beliebten Arbeitgebern.',
    RECRUITERS_SECTION_SECOND_TITLE: 'Du wirst schon erwartet.',
    REGISTER_SECTION_DATE_MARK: 'Heute',
    REGISTER_SECTION_FIRST_TAG: 'Deine Gehalts-Vorstellungen',
    REGISTER_SECTION_HEADLINE: '4 neue Anfragen',
    REGISTER_SECTION_SECOND_TAG: 'Deine Branche',
    REGISTER_SECTION_THIRD_TAG: 'Deine gewünschte Karriere-Stufe',
    SEARCH_AND_SWIPE_SEARCH_WITH_AI: 'Finde Deinen Job mit KI',
    SEO_SECTION_TITLE: 'Mehr Inspiration für Deine Job-Suche',
    TITLE_CARD_1: 'Jobs mit Remote-Optionen',
    TITLE_CARD_2: 'Jobs mit flexiblen Arbeitszeiten',
    TITLE_CARD_3: 'Jobs als Quereinsteiger·in',
    TITLE_CARD_4: 'Jobs mit Top-Bezahlung',
    TITLE_CARD_5: 'Jobs in Teilzeit',
    TITLE_CARD_6: 'Mini-Jobs',
    WELCOME_APP_MINIREG_ERROR_EMAIL: 'Überprüfe bitte Deine E-Mail-Adresse.',
    WELCOME_APP_MINIREG_ERROR_FIRST_NAME: 'Gib hier Deinen Vornamen ein.',
    WELCOME_APP_MINIREG_ERROR_LAST_NAME: 'Gib hier Deinen Nachnamen ein.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_EMAIL:
      'Zu Deiner Sicherheit solltest Du ein anderes Passwort wählen als Deine E-Mail-Adresse.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_LAST_NAME:
      'Zu Deiner Sicherheit solltest Du ein anderes Passwort wählen als Deinen Nachnamen.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_LONG:
      'Dein Passwort sollte aus nicht mehr als 1024 Zeichen bestehen ',
    WELCOME_APP_MINIREG_ERROR_PHONE:
      'Bitte überprüfe nochmal Deine Telefonnummer.',
    WELCOME_APP_MINIREG_ERROR_TANDC:
      'Bitte bestätige die AGB und die Datenschutzbestimmungen.',
    WELCOME_COMPLETION_HEADLINE: 'Willkommen bei XING!',
    WELCOME_COMPLETION_PAGE_META_TITLE: 'Willkommen bei XING! | XING',
    WELCOME_COMPLETION_SUBLINE:
      'Für Deine Registrierung fehlen nur noch diese Angaben:',
    WELCOME_COMPLETION_SUBLINE_B:
      'Dein Profil haben wir für Dich schon angelegt – jetzt fehlt nur noch Dein Name:',
    WELCOME_COMPLETION_SUBLINE_C:
      'Wir zeigen Dir gleich, wen Du bei XING schon kennst. Verrate uns dazu noch Deinen Namen:',
    WELCOME_COMPLETION_SUBLINE_D:
      'Trag jetzt noch Deinen Namen ein, damit Kollegen und Freunde Dich wiedererkennen können:',
    WELCOME_COMPLETION_SUBLINE_E:
      'Wir sind Dein Begleiter im Beruf – und wer bist Du?',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_BODY:
      'Bitte schau nochmal, ob Deine E-Mail Adresse so stimmt. Alles korrekt?  Dann {link}.',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_CTA: 'E-Mail-Adresse korrigieren',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_HEADER:
      'Die E-Mail an Dich ist leider zurückgekommen.',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_SUPPORT_LINK_TEXT: 'schreib uns bitte',
    WELCOME_CONFIRMATION_DEFAULT_BUTTON: 'E-Mail nicht erhalten?',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1: 'Aktiviere jetzt noch Deinen Zugang:',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_C:
      'Wir haben Dir einen Link an {email} geschickt.*',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_D:
      '... haben wir einen Bestätigungslink an {email} geschickt. *',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2:
      'Den Link dazu haben wir an {email} geschickt. *',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_C:
      'Klick darauf, um Deine E-Mail-Adresse zu bestätigen.',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_D:
      'Klick darauf, um Deine Registrierung sicher abzuschließen.',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE: 'Fast geschafft!',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_C: 'Du hast Post:',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_D: 'Zu Deiner Sicherheit ...',
    WELCOME_CONFIRMATION_DEFAULT_SUFFIX:
      '* Nichts zu sehen? Schau auch in den Spam-Ordner. Und wenn Du Gmail nutzt: Vielleicht ist die E-Mail unter "Werbung" oder "Soziale Netzwerke" gelandet.',
    WELCOME_CONFIRMATION_EDIT_EMAIL_BUTTON: 'Neuen Aktivierungslink senden',
    WELCOME_CONFIRMATION_EDIT_EMAIL_COPY:
      'Wenn nicht, kannst Du sie hier korrigieren:',
    WELCOME_CONFIRMATION_EDIT_EMAIL_HEADLINE: 'Stimmt Deine E-Mail-Adresse?',
    WELCOME_CONFIRMATION_EDIT_EMAIL_LABEL: 'E-Mail',
    WELCOME_CONFIRMATION_EDIT_EMAIL_REQUEST_ERROR:
      "Leider ist etwas schief gelaufen. Bitte versuch's nochmal.",
    WELCOME_CONFIRMATION_EMAIL_RESENT_BUTTON: 'E-Mail wieder nicht erhalten?',
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_1:
      'Wir haben Dir einen neuen Aktivierungslink geschickt, an: {email}',
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_2:
      'Schließ jetzt die Registrierung ab: per Klick auf den Aktivierungs-Link in Deiner E-Mail.',
    WELCOME_CONFIRMATION_EMAIL_RESENT_HEADLINE: 'Jetzt aber:',
    WELCOME_CONFIRMATION_PAGE_META_TITLE: 'XING Zugang aktivieren | XING',
    WELCOME_GDPR_IMG_ALT: 'Datenschutz bei XING ist im Einklang mit der DSGVO.',
    WELCOME_INVITATION_HEADLINE: '{firstname} {lastname} lädt Dich ein.',
    WELCOME_INVITATION_SUBLINE:
      'Registrier Dich hier, um {firstname} als XING Kontakt zu bestätigen.',
    WELCOME_LANGUAGE_PAGE_META_TITLE: 'Sprache auswählen | XING',
    WELCOME_LANGUAGE_SELECT_ENGLISH_LABEL: 'English',
    WELCOME_LANGUAGE_SELECT_FRENCH_LABEL: 'Français',
    WELCOME_LANGUAGE_SELECT_GERMAN_LABEL: 'Deutsch',
    WELCOME_LANGUAGE_SELECT_HEADLINE:
      'In welcher Sprache möchtest Du XING nutzen?',
    WELCOME_LANGUAGE_SELECT_ITALIAN_LABEL: 'Italiano',
    WELCOME_LANGUAGE_SELECT_SPANISH_LABEL: 'Español',
    WELCOME_LOGIN_FORM_EMAIL_REQUIRED_ERROR:
      'Gib hier Deine E-Mail-Adresse ein.',
    WELCOME_LOGIN_FORM_FIRSTNAME_REQUIRED_ERROR:
      'Gib hier Deinen Vornamen ein.',
    WELCOME_LOGIN_FORM_LASTNAME_REQUIRED_ERROR:
      'Gib hier Deinen Nachnamen ein.',
    WELCOME_LOGIN_FORM_PASSWORD_REQUIRED_ERROR: 'Gib hier Dein Passwort ein.',
    WELCOME_LOGIN_FORM_PASSWORD_REQURED_ERROR: 'Gib hier Dein Passwort ein.',
    WELCOME_LOGIN_FORM_REMEMEMBER_ME_LABEL: 'Eingeloggt bleiben',
    WELCOME_LOGIN_FORM_SUBMIT_REQUEST_ERROR:
      "Das hat leider nicht geklappt. Versuch's bitte noch einmal.",
    WELCOME_LOGIN_FORM_USERNAME_REQUIRED_ERROR:
      'Gib hier Deine E-Mail-Adresse ein.',
    WELCOME_LOGIN_HEADLINE: 'Willkommen zurück!',
    WELCOME_LOGIN_PASSWORD_LABEL: 'Passwort',
    WELCOME_LOGIN_PROBLEMS_LOGGING_IN: 'Probleme beim Einloggen?',
    WELCOME_LOGIN_SUBMIT_LABEL: 'Einloggen',
    WELCOME_LOGIN_USERNAME_LABEL: 'E-Mail',
    WELCOME_REGISTRATION_CTA_REG_7503_E: 'Neues Profil erstellen',
    WELCOME_REGISTRATION_CTA_REG_7504_A: 'Weiter',
    WELCOME_REGISTRATION_CTA_REG_7504_B: 'Registrieren',
    WELCOME_REGISTRATION_CTA_REG_7504_C: 'Jetzt registrieren',
    WELCOME_REGISTRATION_CTA_REG_7504_D: 'Profil erstellen',
    WELCOME_REGISTRATION_CTA_REG_7504_E: 'XING beitreten',
    WELCOME_REGISTRATION_DATAPROTECTION_LABEL: 'Datenschutzerklärung',
    WELCOME_REGISTRATION_DATAPROTECTION_LINK:
      'https://privacy.xing.com/de/datenschutzerklaerung',
    WELCOME_REGISTRATION_EMAIL_LABEL: 'E-Mail',
    WELCOME_REGISTRATION_FIRSTNAME_LABEL: 'Vorname',
    WELCOME_REGISTRATION_HEADLINE: 'Hol Dir Dein kostenloses XING Profil:',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_B:
      'Jetzt registrieren – gratis und in nur 2 Minuten!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_C:
      'Jetzt registrieren – gratis und in nur 2 Minuten!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_D:
      'Jetzt registrieren – gratis und in nur 2 Minuten!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_E:
      'Jetzt registrieren – gratis und in nur 2 Minuten!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_B:
      'Registrier Dich hier mit nur wenigen Klicks:',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_C:
      'Mach jetzt mehr aus Deinem Beruf:',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_D:
      'Hol Dir Dein kostenloses XING Profil:',
    WELCOME_REGISTRATION_HEADLINE_REG_7550_CMP:
      'Meld Dich jetzt an und nutz Premium 30 Tage gratis:',
    WELCOME_REGISTRATION_IGNORE_SOFT_EMAIL_ERRORS_LABEL:
      'Ja, {email} ist meine korrekte E-Mail-Adresse.',
    WELCOME_REGISTRATION_LASTNAME_LABEL: 'Nachname',
    WELCOME_REGISTRATION_PASSWORD_LABEL: 'Passwort',
    WELCOME_REGISTRATION_RECAPTCHA_HEADLINE: 'Fast geschafft!',
    WELCOME_REGISTRATION_RECAPTCHA_PARAGRAPH:
      'Um Dich und andere vor Spam zu schützen, möchten wir sichergehen, dass Du eine echte Person bist.',
    WELCOME_REGISTRATION_SOFT_EMAIL_ERROR:
      'Prüf bitte nochmal, ob Deine E-Mail-Adresse wirklich korrekt ist.',
    WELCOME_REGISTRATION_SUBMIT_LABEL: 'Weiter zur Bestätigung',
    WELCOME_REGISTRATION_TANDC_DESCRIPTION:
      'Ich akzeptiere die {tandc} und habe die {dataprotection} zur Kenntnis genommen.',
    WELCOME_REGISTRATION_TANDC_LABEL: 'AGB',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_BUTTON:
      'Hier klicken und 5 Sekunden lang gedrückt halten',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_ERROR:
      'Das hat leider nicht geklappt – klick mit der Maustaste auf den Button und lass sie 5 Sekunden lang nicht los.',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_HEADLINE:
      'Und jetzt noch eine Sicherheitsprüfung',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_PARAGRAPH:
      'Damit verhindern wir, dass Bots ihr Unwesen auf XING treiben: Klick diesen Button und halte ihn 5 Sekunden lang gedrückt.',
    WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL:
      'Die Datei ist entweder zu groß oder im falschen Format. Tipp: PDFs funktionieren am besten und sind in der Regel recht klein.',
    WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL: 'Datei auswählen und hochladen',
    WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL:
      "Das hat leider nicht geklappt. Versuch's bitte nochmal.",
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT:
      'Lade jetzt Deinen Lebenslauf hoch und wir schicken Dir Job-Vorschläge zu.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS:
      'Wir haben Deinen Lebenslauf automatisch mit Deinen Daten befüllt.{br}{br} Bitte schau kurz, ob alles stimmt, und trag die Infos ein, die noch fehlen.',
    WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL:
      'Formate: Adobe (PDF), Word (docx) oder Apple (PAGES), max. 100 MB',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT:
      'Lass Dich von Recruiter·innen finden',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS: 'Dein Lebenslauf',
    WELCOME_SEARCHPAGE_CTA:
      'Entdecke hier Deinen nächsten Job – oder Kollegen und Freunde:',
    WELCOME_SEARCHPAGE_HEADLINE: 'Finde Jobs oder Mitglieder:',
    WELCOME_SEARCHPAGE_JOBS_BUTTON: 'Jobs',
    WELCOME_SEARCHPAGE_JOBS_PLACEHOLDER: 'Job-Titel oder Stichwort eingeben',
    WELCOME_SEARCHPAGE_MEMBERS_BUTTON: 'Mitglieder',
    WELCOME_SEARCHPAGE_MEMBERS_PLACEHOLDER:
      'Name, Firma oder Suchwort eingeben',
    WELCOME_SEARCHPAGE_SEARCH_BUTTON: 'Suchen',
    WELCOME_SIGNUP_FORM_SUBMIT_REQUEST_ERROR:
      "Das hat leider nicht geklappt. Bitte versuch's nochmal.\n",
    WELCOME_SIGNUP_FORM_VALIDATE_RELOAD_ERROR:
      'Das hat leider nicht geklappt. Aktiviere bitte einmal die Cookies in den Einstellungen Deines Browsers und lade diese Seite dann neu.',
    WELCOME_SIGNUP_FORM_VALIDATE_REQUEST_ERROR:
      "Das hat leider nicht geklappt. Bitte versuch's noch einmal.",
    WELCOME_SIGNUP_PAGE_META_TITLE: 'Jetzt kostenlos registrieren | XING',
    WELCOME_SIGNUP_USP_CONTACTS_COPY:
      'Lass Dich finden von Arbeitgebern und über 20.000 Recruiter·innen.',
    WELCOME_SIGNUP_USP_CONTACTS_TITLE: 'Persönliche Job-Angebote',
    WELCOME_SIGNUP_USP_FREE_COPY:
      'Schon als Basis-Mitglied kannst Du Deine Job-Suche deutlich optimieren.',
    WELCOME_SIGNUP_USP_FREE_TITLE: 'Kostenlos profitieren',
    WELCOME_SIGNUP_USP_PRESENCE_COPY:
      'Entdecke mit XING genau den Job, der wirklich zu Dir passt.',
    WELCOME_SIGNUP_USP_PRESENCE_TITLE: 'Über eine Million Jobs',
    WELCOME_SIGNUP_USP_SECURITY_COPY:
      'Knüpf neue Kontakte und erhalte Impulse für ein besseres Job-Leben.',
    WELCOME_SIGNUP_USP_SECURITY_TITLE: '21 Mio. Mitglieder',
    WELCOME_SIGNUP_USPS_TITLE: 'XING – Das Jobs-Netzwerk',
    WELCOME_STARTPAGE_APP_STORE_BADGE_ALT: 'Laden im App Store',
    WELCOME_STARTPAGE_CULTURE_CHECK_BUTTON: 'Zum Kultur-Check',
    WELCOME_STARTPAGE_CULTURE_CHECK_IMG_ALT:
      'Eine Illustration des Kultur-Checks',
    WELCOME_STARTPAGE_CULTURE_CHECK_TEXT:
      'Flache Hierarchien oder klare Vorgaben? Mehr Work oder mehr Life? Faktoren, die Unternehmenskultur beschreiben, gibt es viele – finde mit dem Kultur-Check heraus, wie Deine ganz persönliche Prioliste aussieht. Damit Du beim nächsten Jobwechsel weißt, worauf es Dir ankommt. Probier’s gleich aus:',
    WELCOME_STARTPAGE_CULTURE_CHECK_TITLE: 'Arbeiten, wo Du Dich wohlfühlst.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_BUTTON: 'Zum Kulturkompass',
    WELCOME_STARTPAGE_CULTURE_COMPASS_IMG_ALT:
      'Eine Grafik zur Unternehmenskultur mit einer Skala von traditionell bis modern.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_TEXT:
      'Hast Du Dich nicht auch schon immer gefragt, wie die Leute im Unternehmen XY so ticken? Mit dem Kulturkompass schaust Du hinter die Kulissen Deines Wunsch-Arbeitgebers. Hier gibt’s viele wichtige Einblicke in Unternehmen, die Dich interessieren. So weißt Du schon vor der Bewerbung, ob es passt.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_TITLE: 'Folge dem Kulturkompass.',
    WELCOME_STARTPAGE_DOWNLOAD_APP_CTA: 'Bereit für die XING App?',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_01:
      'Registrier Dich dafür gratis – in nur 2 Minuten:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_02:
      'Registrier Dich dafür gratis – in nur 2 Minuten:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_03:
      'Werd kostenlos Mitglied – in nur 2 Minuten:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_04:
      'Registrier Dich dafür gratis – in nur 2 Minuten:',
    WELCOME_STARTPAGE_GOOGLE_PLAY_BADGE_ALT: 'Jetzt bei Google Play',
    WELCOME_STARTPAGE_HEADER_BUTTON: 'Jetzt registrieren',
    WELCOME_STARTPAGE_HEADER_IMAGE_ALT:
      'Glückliche Frau, die sich auf einem Stuhl ausstreckt',
    WELCOME_STARTPAGE_HEADER_SUBTITLE: 'Mach Dein XING!',
    WELCOME_STARTPAGE_HEADER_TITLE: 'Zeit, Dich beruflich zu entfalten.',
    WELCOME_STARTPAGE_JOBS_DIRECTORY_NAVIGATION_TITLE: 'Jobs von A bis Z',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_BUTTON: 'Kostenlos registrieren',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_SUBTITLE:
      "Oder wir finden ihn für Dich! Probier's aus:",
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_TITLE:
      'Finde den Job,{br}\nder wirklich passt:',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_DOGS_FRIENDLY: 'Hunde willkommen',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_FLEXIBILITY:
      'Flexible Arbeitszeiten',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_PART_TIME: 'Teilzeit',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_REMOTE: 'Home-Office',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_INPUT_PLACEHOLDER:
      'Job-Titel oder Stichwort eingeben',
    WELCOME_STARTPAGE_JOBS_VERSION_LOCATION_INPUT_PLACEHOLDER: 'Standort',
    WELCOME_STARTPAGE_JOBS_VERSION_SEARCH_SUBMIT_BUTTON: 'Job finden',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_IMG_ALT:
      'Zeichnung einer Person und eines Lebenslaufs',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TEXT:
      "Ob Umzug, veränderte Lebenssituation oder einfach Lust auf was Neues: Bei XING geht's weniger darum, was war oder ist – es geht vor allem darum, wo Du im Job-Leben noch hinwillst. Ganz ohne Dich verbiegen zu müssen.",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TITLE:
      'Bei XING bist Du mehr als nur Dein Lebenslauf',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_IMG_ALT:
      'Zeichnung einer Person mit einem Bild, auf dem verschiedene Köpfe zu sehen sind',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TEXT:
      'Bei XING sind über 20.000 Recruiter·innen nur eine Nachricht weit entfernt. Du triffst auf echte HR-, Branchen- und Arbeitsmarkt-Expert·innen und knüpfst direkten Kontakt zu Personalern und Mitarbeitenden Deines Wunsch-Arbeitgebers. Mach mit und mach Dein XING!',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TITLE:
      "Wissen, wie's die anderen machen",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_IMG_ALT:
      'Zeichnung einer Person mit unterschiedlichen berufstypischen Hüten',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TEXT:
      'Hier findest Du die meisten und besten Stellenangebote und bekommst passende Empfehlung zur richtigen Zeit. Um herauszufinden, was Du wirklich willst. Um Dich weiterzubilden. Um spannende Arbeitgeber zu entdecken, die genau die Unternehmenskultur bieten, die Du liebst.',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TITLE:
      'Über eine Million Jobs und alle Möglichkeiten',
    WELCOME_STARTPAGE_JOBSFINDER_CTA_BUTTON: 'Direkt registrieren',
    WELCOME_STARTPAGE_JOBSFINDER_CTA_TEXT:
      'Wie sich Standort und Branche aufs Gehalt auswirken? Erfährst Du mit XING.',
    WELCOME_STARTPAGE_JOBSFINDER_IMG_ALT:
      'Frau, die versucht, in einer unbequemen Position zu arbeiten',
    WELCOME_STARTPAGE_JOBSFINDER_SUBTITLE: 'Nie mehr verbiegen:',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_CONSULTING: 'Beratung',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_IT: 'IT',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_LOGISTICS: 'Logistik',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MARKETING: 'Marketing',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MORE_JOBS: 'Mehr Bereiche',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_PROJECT_MANAGEMENT:
      'Projekt-Management',
    WELCOME_STARTPAGE_JOBSFINDER_TITLE:
      'Finde den Job, der wirklich zu Dir passt.',
    WELCOME_STARTPAGE_KEY_FEATURES_EVENTS: '1,7 Millionen Events',
    WELCOME_STARTPAGE_KEY_FEATURES_JOBS: 'Über 250.000 Jobs',
    WELCOME_STARTPAGE_KEY_FEATURES_MEMBERS: '21 Millionen Mitglieder',
    WELCOME_STARTPAGE_KEY_FEATURES_NEWS: 'Täglich neue Branchen-News',
    WELCOME_STARTPAGE_MAIN_CTA_BUTTON: 'Jetzt kostenlos registrieren',
    WELCOME_STARTPAGE_MAIN_CTA_TEXT:
      'XING – das größte Jobs-Netzwerk im deutschsprachigen Raum.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION:
      'XING ist der persönliche Begleiter für Dein Job-Leben. Knüpfe berufliche Kontakte und entdecke spannende Jobs und Fach-News.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_B:
      'Find a job to match your lifestyle.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_C:
      'Ein Ort. Viele Menschen, die Dich interessieren. Erfahre das Neueste, teile Deine Ideen und hol Dir Inspiration.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_D:
      'Schau nach, was Deine Kolleginnen und Kollegen gerade machen. Tausch Dich mit den Menschen aus, die das Gleiche antreibt wie Dich.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_E:
      'Ein Ort. Viele Menschen. Teile Deine Ideen, hol Dir Inspiration und erfahre immer das Neueste.',
    WELCOME_STARTPAGE_MAIN_SUBTITLE_REG_7494:
      'Für Dein Leben. Für Deinen Job. Für Dein Job-Leben.',
    WELCOME_STARTPAGE_MAIN_TITLE: 'XING – Ideen für eine neue Arbeitswelt',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_B: 'Find the right job for you',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_C:
      'Stärken bündeln. In Deinem Netzwerk.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_D:
      'Dein Job-Leben? Ein Gemeinschaftsding.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_E:
      'Im Job-Leben die Richtigen kennen.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_01:
      'Besser arbeiten, besser leben: mit dem passenden Job.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_02:
      'Mach Schluss mit "Eigentlich ..." – und finde einen Job, der passt.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_03: 'XING – Dein Begleiter im Beruf.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_04:
      'Besser arbeiten, besser leben: mit dem passenden Job.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7494: 'Weil Du’s Dir vorgenommen hast.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7747:
      'Zeit, Dich zu entfalten.{br}\nMach Dein XING!',
    WELCOME_STARTPAGE_MEMBER_DIRECTORY_NAVIGATION_TITLE:
      'Mitglieder von A bis Z',
    WELCOME_STARTPAGE_META_DESCRIPTION:
      'XING ist der persönliche Begleiter für Deinen Beruf. Knüpfe berufliche Kontakte, entdecke spannende Jobs und hol Dir wertvolle Tipps für Dein Job-Leben.',
    WELCOME_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      '✓ Kultur-Check ✓ Arbeitgeber-Bewertungen ✓ e-Learning ✓ Recruiter-Kontakte - Mach Dein XING für mehr Sinn und Zufriedenheit im Job-Leben',
    WELCOME_STARTPAGE_META_TITLE: 'XING – Ideen für eine neue Arbeitswelt',
    WELCOME_STARTPAGE_META_TITLE_JOB_SEARCH:
      'XING - Finde den Job, der wirklich zu Dir passt',
    WELCOME_STARTPAGE_OG_SITENAME: 'XING',
    WELCOME_STARTPAGE_OG_TITLE: 'XING – Ideen für eine neue Arbeitswelt',
    WELCOME_STARTPAGE_PROCEED_WITH_APPLE_BUTTON: 'Weiter mit Apple',
    WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON: 'Weiter mit Google',
    WELCOME_STARTPAGE_XINGGUIDE_BUTTON: 'Mehr erfahren',
    WELCOME_STARTPAGE_XINGGUIDE_IMG_ALT:
      'Eine Nachricht vom XING Guide, der ein Stellenangebot empfiehlt',
    WELCOME_STARTPAGE_XINGGUIDE_TEXT:
      'Du bist auf Job-Suche oder hast gerade einen neuen Job gestartet? Dann hilft Dir der Guide mit Tipps, wie Du Dich auf XING noch besser aufstellst: vom Optimieren Deines Profils bis zu Empfehlungen von passenden Kontakten oder Artikeln – je nachdem, was Du gerade brauchst.',
    WELCOME_STARTPAGE_XINGGUIDE_TITLE: 'Dein Begleiter im Job-Leben.',
    WELCOME_TOGGLE_FORM_BUTTON_LOGIN: 'Einloggen',
    WELCOME_TOGGLE_FORM_BUTTON_REGISTER: 'Registrieren',
  },
};
